<div class="container">
  <div class="comparison__container">
    <div class="comparison__titles no-mobile" [ngClass]="{ 'comparison__hub-pages': isHubPage }">
      <div class="comparison__input-select-holder"></div>
      <div class="comparison__input-holder comparison__entry-0">
        <span class="comparison__inner-text" i18n="@@product.smartDetection">SMART DETECTION</span>
      </div>
      <div class="comparison__input-holder comparison__entry-1">
        <span class="comparison__inner-text" i18n="@@product.IA">I.A</span>
      </div>
      <div class="comparison__input-holder comparison__entry-2">
        <span class="comparison__inner-text" i18n="@@product.bluetooth">BLUETOOTH</span>
      </div>
      <div class="comparison__input-holder comparison__entry-3">
        <span class="comparison__inner-text" i18n="@@product.battery">BATTERY</span>
      </div>
      <div class="comparison__input-holder comparison__entry-4">
        <span class="comparison__inner-text" i18n="@@product.smartMode">SMART MODE</span>
      </div>
      <div class="comparison__input-holder comparison__entry-5">
        <span class="comparison__inner-text" i18n="@@product.timmer">TIMMER</span>
      </div>
      <div class="comparison__input-holder comparison__entry-6">
        <span class="comparison__inner-text" i18n="@@product.display">DISPLAY</span>
      </div>
      @if (!isHubPage) {
        <div class="comparison__input-holder comparison__entry-7">
          <span class="comparison__inner-text" i18n="@@product.accesories">ACCESORIES</span>
        </div>
      }
    </div>
    <div class="comparison__items">
      @for (product of selectedProducts; track product; let i = $index) {
        <div class="comparison__item" [ngClass]="{ 'no-mobile': i === 2 }">
          <app-recommended-comparison-element
            [products]="products"
            [initialSelected]="product"
            [index]="i"
            [bazaarvoiceReviews]="bazaarvoiceReviews && bazarvoiceReviews"
            [isHubPage]="isHubPage"
            [displayAccesories]="AccesoriesOpen"
            [displayModes]="ModesOpen"
            (displayAccesoriesEvent)="changeDisplay($event)"
            (displayModesEvent)="changeModesDisplay($event)"
          />
        </div>
      }
    </div>
  </div>
</div>
